var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell",class:{ header: _vm.isHeader, bg: _vm.isExpanded }},[_c('hbox',{staticClass:"align-baseline fill table-row"},[_vm._t("default")],2),_c('vbox',{},[_c('Transition',{attrs:{"name":"cell-expanded"}},[(_vm.expanded)?_vm._t("expanded"):_vm._e()],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }